// El botón de preorder no existe en el HTML renderizado: la clase
// .restock-rocket-preorder-button la añade main-product.liquid al cambiar de variante
// (después de un fetch de disponibilidad), y la quita cuando la variante sí tiene stock.
// Por eso se delega el click en document en vez de enlazar los botones al cargar.
(() => {
    document.addEventListener('click', (evt) => {
        const btn = evt.target.closest?.('.restock-rocket-preorder-button');
        if (!btn) return;
        openPopup();
    });

    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    function openPopup() {
        // Evita apilar varios overlays si se hace más de un click.
        if (document.querySelector('.popup-overlay')) return;

        const uniqueId = generateUUID();

        const overlay = document.createElement('div');
        overlay.id = `popup-overlay-${uniqueId}`;
        overlay.className = 'popup-overlay';
        Object.assign(overlay.style, {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        });

        const modal = document.createElement('div');
        modal.id = `popup-modal-${uniqueId}`;
        modal.className = 'popup-modal';
        Object.assign(modal.style, {
            background: '#fff',
            padding: '28px',
            borderRadius: '0px',
            maxWidth: '500px',
            width: '90%',
            position: 'relative',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        });

        const content = document.createElement('div');
        content.innerHTML = `
          <h1 class="preorder-popup-title">Hi! This style is a pre-order of one of our newest arrivals.</h1> 
          <p class="preorder-popup-text">We’ll ship your order as soon as it’s ready and keep you in the loop every step of the way.</p>       
          `;

        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = "Secure My Pair";
        Object.assign(closeBtn.style, {
            marginTop: '20px',
            padding: '10px 20px',
            border: 'none',
            background: '#700',
            color: '#fff',
            fontSize: '16px',
            cursor: 'pointer',
            borderRadius: '0px',
        });

        closeBtn.addEventListener('click', (evt) => {
            evt.stopPropagation();
            document.getElementById(`popup-overlay-${uniqueId}`).remove();
        });

        modal.append(content, closeBtn);
        overlay.append(modal);
        document.body.append(overlay);
    }
})();